module.exports = __webpack_public_path__ + "0aefa6beccfc327e78039f568d06ac60.pdf";